import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AccountService } from '../../../../../../services/account/account.service';
import { DocumentTemplateService } from '../../../../../../services/document-template/document-template.service';
import { DocumentTemplate, DocumentType } from '../../../../../../models/document-template';

@Component({
  selector: 'app-document-template-add',
  templateUrl: './document-template-add.component.html',
  styleUrls: ['./document-template-add.component.css']
})
export class DocumentTemplateAddComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private documentTemplateService: DocumentTemplateService
  ) {}

  public documentTemplate: DocumentTemplate;

  public documentTemplateErrorMessage = '';
  public documentTemplateErrors: any = {};

  public loadingTemplate = false;

  public serverError: number = null;

  ngOnInit() {
    this.documentTemplate = {
      id: null,
      url: '',
      climber_app_url: '',
      document_type: DocumentType.waiver,
      name: '',
      is_location_restricted: false,
      allowed_locations: [],
      can_be_used_for_barcode_check_in: true,
      is_removed: false,
      is_available_in_kiosk_mode: true,
      is_available_in_climber_app: true,
      quiz_error_message_kiosk: '',
      quiz_error_message_climber_app: '',
      quiz_error_alert_immediately_climber_app: true,
      quiz_error_create_inbox_item_climber_app: true,
      is_available_to_adult_participants: true,
      is_available_to_adults_with_minors: false,
      is_available_to_minors: false,
      is_available_to_unsupervised_minors: false,
      is_available_to_adults_with_supervised_adults: false,
      is_available_to_supervisors_alone: false,
      is_available_to_supervisors_with_supervisees: true,
      adult_min_age: null,
      minor_max_age: null,
      max_secondary_customer_count: 5,
      // The appropriate initial sections will be added by the API.
      sections: [],
      welcome_text: '',
      confirmation_text: '',
      days_to_expiration: null,
      years_to_expiration: null,
      expire_when_minor_becomes_adult: false,
      send_expiring_soon_email: false,
      expiring_soon_email_lead_days: 14,
      expiring_soon_email_text: '',
      expiring_soon_email_include_button: true,
      expiring_soon_email_button_text: '',
      send_expired_email: false,
      expired_email_text: '',
      expired_email_include_button: true,
      expired_email_button_text: '',
      counts_as_waiver_for_supervisees: false,
      requires_staff_approval: false,
      order_number: 0,
      granted_adult_proficiencies: [],
      granted_adult_non_participant_proficiencies: [],
      granted_minor_proficiencies: [],
      granted_unsupervised_minor_proficiencies: [],
      granted_supervised_adult_proficiencies: [],
      granted_supervisor_proficiencies: [],
      granted_supervisee_proficiencies: [],
      granted_climber_proficiencies: [],
      created_at: '',
      updated_at: ''
    };
  }

  /**
   * Save the document template, then redirect to the edit page for the
   * newly-created document if successful.
   */
  public handleSave() {
    this.loadingTemplate = true;

    this.documentTemplateErrorMessage = '';

    this.documentTemplateService
      .addDocumentTemplate(this.documentTemplate)
      .then(updatedDocumentTemplate => {
        this.documentTemplate = updatedDocumentTemplate;

        this.router.navigate(
          ['/document-templates/' + this.documentTemplate.id.toString()]
        );
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.documentTemplateErrors = reason.error;
          this.documentTemplateErrorMessage = 'Please correct the provided errors and try again.';
        } else if (reason.status === 403) {
          this.documentTemplateErrorMessage = 'You do not have permission to create document templates.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingTemplate = false; });
  }

}
